import React, { useState } from 'react';
import './SuffixField.css';
import { regexValidation } from '../../../utils/cob-utils';
import { InputBase } from 'component-library/index';
import { generateFieldErrorMessage } from '../../../utils/error-message';

export interface ISuffixFieldProps {
    label?: string | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactElement<any, string | React.JSXElementConstructor<any>>[];
    inputClass?: string;
    value: string;
    setValueCallback?: THandlerFunction;
    valid?: [boolean, (arg?: any) => void];
    disabled?: boolean;
    error?: boolean;
    onBlurCallback?: THandlerFunction;
    useSuccessIcon?: boolean;
    invalidErrorMessage?: string;
}

export default function SuffixField(props: ISuffixFieldProps & React.HTMLAttributes<HTMLInputElement>) {
    const [isFocused, setIsFocused] = useState(true);

    const getValidSubstring = (suffix: string) => {
        const validationResult = regexValidation().allow.name_suffix.exec(suffix);
        return validationResult[0];
    };

    const isSuffixValid = (suffix: string) => {
        if (!suffix) {
            return true;
        }

        const validationResult = getValidSubstring(suffix);
        return !!validationResult;
    };

    return (
        <div className='SuffixField'> 
            <InputBase
                label={props.label}
                id='suffix'
                isValid={isSuffixValid}
                setValue={(value: string) => {
                    props.setValueCallback(value);
                }}
                onFocus={() => {
                    setIsFocused(true);
                }}
                onBlur={() => {
                    setIsFocused(false);

                    let updatedValue = props.value;
                    const isValid = isSuffixValid(updatedValue);

                    if (isValid) {
                        updatedValue = getValidSubstring(props.value);
                        props.setValueCallback(updatedValue);
                    }
                    props.onBlurCallback && props.onBlurCallback(updatedValue, isValid);
                }}
                value={props.value}
                error={props.error}
                errorText={generateFieldErrorMessage('Suffix')}
                disabled={props.disabled}
                maxLength={4}
                invalidErrorMessage={props.invalidErrorMessage}
                showExclamationError
                useSuccessIcon={props.useSuccessIcon}
                showSuccessIcon={props.useSuccessIcon && !isFocused && isSuffixValid(props.value)}
                alternate
            />
        </div>
    );
}